import http from '@/requests/http'
import appConfig from '@/config/app'
import utilityHelper from '@/helpers/utils'

class AutoCallSystem {
  static all (params) {
    return http.post('auto-call-system/index', params)
  }
  static destroy (params) {
    return http.post('auto-call-system/destroy', params)
  }
  static checkAgentQueueStatus (params) {
    return http.post('auto-call-system/check-agent-queue-status', params)
  }
  static sendDataToPBX (params) {
    return http.post('auto-call-system/send-request-to-pbx', params)
  }
  static getCurrentStatus (params) {
    return http.post('auto-call-system/get-current-status', params)
  }
  static deleteAutoCallSystemData (params) {
    return http.post('auto-call-system/delete', params)
  }
  static async store (data) {
    const formData = new FormData()
    await utilityHelper.buildFormData(formData, data)
    return http.post('auto-call-system/store', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  static async downloadSampleImportFile (language) {
    window.open(`${appConfig.apiBaseUrl}/auto-call-system/import/sample/${language}`, '_blank')
  }
  static async exportAutoCallSystemData (companyId, userId, language, params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl}/auto-call-system/export/${companyId}/${userId}/${language}?${URLparams}`, '_blank')
  }
}

export default AutoCallSystem
